import { render, staticRenderFns } from "./AnalyzesDetail.vue?vue&type=template&id=1a785deb&"
import script from "./AnalyzesDetail.vue?vue&type=script&lang=js&"
export * from "./AnalyzesDetail.vue?vue&type=script&lang=js&"
import style0 from "./AnalyzesDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports